import React from "react"
import "./css/Aside.min.css"

const aside = {
  asideWrapper: children => (
    <div className="product-aside" children={children} />
  ),
  title: "Products",
  items: [
    {
      title: "Qoqolo",
      to: "/products/qoqolo/",
      child: [],
    },
    {
      title: "Dudu Chinese",
      to: "/products/dudu/",
      child: [],
    },
    {
      title: "Readin English",
      to: "/products/readin/",
      child: [],
    },
    {
      title: "CommonAcademy",
      to: "/products/commonacademy/",
      child: [],
    },
    {
      title: "Discovery Club",
      to: "/discovery-club/",
      child: [],
    },
    {
      title: "SWIIIT",
      to: "/products/swiiit/",
      child: [],
    },
    {
      title: "Vatitude",
      to: "/products/vatitude/",
      child: [],
    },
    {
      title: "Mobile Practice Apps",
      to: "/slay/",
      child: [],
    },
    
    // {
    //   title: "Qoqolo Elderly",
    //   to: "/products/qoqolo-elderly/",
    //   child: [],
    // },
   
    // {
    //   title: "Dudu Together",
    //   to: "/products/dudu-together/",
    //   child: [],
    // },
    
    
  ],
  footer: null,
}

export default aside
